<template>
  <div class="field">
    <div class="label">证件号码</div>
    <div class="value">
      <input
        class="txr-asterisk"
        type="text"
        :value="value"
        @input="onInput"
        placeholder="请输入您的证件号码"
        :class="{ disabled }"
        :disabled="disabled"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: [String, Number],
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onInput(event) {
      this.$emit("input", event.target.value);
    }
  }
}
</script>

<style scoped>
input {
  text-align: right;
}
</style>